import { render } from "./ProcessSanggah.vue?vue&type=template&id=3c288272&scoped=true"
import script from "./ProcessSanggah.vue?vue&type=script&lang=js"
export * from "./ProcessSanggah.vue?vue&type=script&lang=js"

import "./ProcessSanggah.vue?vue&type=style&index=0&id=3c288272&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c288272"]])

export default __exports__